import { FormData } from '~/training/sequence/templates/items/chatBot/components/forms/AIScenarioForm';

export const validateChatBotForm = (formData: FormData): boolean => {
  return formData.topic.trim().length > 0;
};
